export type ModelMode = "create" | "edit" | "view";

export const getGridStyle = () => ({
  height: "85vh",
  width: "100%"
});
